import { colorPalette } from 'ui-blocks/ColorPalette';

export const unlockNewStyles = {
	imagesContainer: {
		display: 'grid',
		gridTemplateColumns: {
			xs: 'repeat(1, 1fr)',
			sm: 'repeat(2, 1fr)',
			mobileUi: 'repeat(3, 1fr)',
		},
		gap: { xs: '29px', sm: '20px', mobileUi: '36px' },
		width: '100%',
	},
	imageContainer: {
		position: 'relative',
		aspectRatio: '1.12',
		border: `1px solid ${colorPalette.dark1}`,
		borderRadius: { xs: '16px', smTab: '32px' },
		overflow: 'hidden',
	},
	imageBaseStyle: {
		height: '100%',
		width: '100%',
		objectFit: 'cover',
	},
	imageContent: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		right: 0,
		padding: '8px 20px',
		backgroundColor: 'colors.dark6',
		opacity: 0.8,
	},
};
